import React from 'react';
import type { ViewerSupportConfig } from '../../../server/admin/viewer-config/types';

interface SupportConfigTabProps {
  value: ViewerSupportConfig;
  onChange: (updated: ViewerSupportConfig) => void;
}

export function SupportConfigTab({ value, onChange }: SupportConfigTabProps) {
  const updateField = (field: 'email' | 'phone', val: string) => {
    onChange({ ...value, [field]: val || null });
  };

  const addFaq = () => {
    const faqLinks = [...(value.faqLinks || []), { label: '', url: '' }];
    onChange({ ...value, faqLinks });
  };

  const updateFaq = (index: number, field: 'label' | 'url', val: string) => {
    const faqLinks = [...(value.faqLinks || [])];
    faqLinks[index] = { ...faqLinks[index], [field]: val };
    onChange({ ...value, faqLinks });
  };

  const removeFaq = (index: number) => {
    const faqLinks = (value.faqLinks || []).filter((_, i) => i !== index);
    onChange({ ...value, faqLinks });
  };

  return (
    <div>
      <div className="vc-field">
        <label className="vc-label">Support Email</label>
        <input
          className="vc-input"
          type="email"
          value={value.email || ''}
          onChange={(e) => updateField('email', e.target.value)}
          placeholder="support@company.com"
        />
      </div>

      <div className="vc-field">
        <label className="vc-label">Support Phone</label>
        <input
          className="vc-input"
          type="tel"
          value={value.phone || ''}
          onChange={(e) => updateField('phone', e.target.value)}
          placeholder="+1 800 555 0199"
        />
      </div>

      <div className="vc-field">
        <label className="vc-label">FAQ Links</label>
        <div className="vc-list">
          {(value.faqLinks || []).map((faq, index) => (
            <div key={index} className="vc-list-item">
              <div className="vc-list-item-header">
                <span style={{ flex: 1, fontSize: '0.75rem', color: 'rgba(255,255,255,0.4)' }}>
                  FAQ #{index + 1}
                </span>
                <button
                  type="button"
                  className="vc-list-item-delete"
                  onClick={() => removeFaq(index)}
                  title="Remove FAQ"
                >
                  ✕
                </button>
              </div>
              <div className="vc-list-item-fields">
                <input
                  className="vc-input"
                  type="text"
                  value={faq.label}
                  onChange={(e) => updateFaq(index, 'label', e.target.value)}
                  placeholder="Label (e.g. Installation Guide)"
                />
                <input
                  className="vc-input"
                  type="url"
                  value={faq.url}
                  onChange={(e) => updateFaq(index, 'url', e.target.value)}
                  placeholder="https://..."
                />
              </div>
            </div>
          ))}
        </div>

        <button type="button" className="vc-add-btn" onClick={addFaq}>
          + Add FAQ Link
        </button>
      </div>
    </div>
  );
}
